module.exports = __webpack_public_path__ + "img/geofisica2_4-3_2048.bdb5e15c.webp";